module.exports = "<div class=\"container\">\n  <div class=\"content\">\n    <div style=\"font-size: 28px\"> 505 Error</div>\n    <div style=\"font-size: 18px\"> Solicitud no encontrada</div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error505/error505.component.html
// module id = ./src/app/components/error505/error505.component.html
// module chunks = main